const getBaseConfig = require('../../common/getBaseConfig');
const { delegateEvent } = require('../../utilities/javascriptUtils');
const { isAnonymousCustomer } = require('../analytics/abandonedCart');
const { validateEmail } = require('../clientSideValidation').functions;
const modalFactory = require('./modalFactory');

const BASE_CONFIG = getBaseConfig();

/**
 * Set email blur event
 * publish event if email is valid
 * @param {modalFactory.ModalComponentInstance} modalComponentInstance The modal component
 */
function setEmailBlurEvent(modalComponentInstance) {
    var selector = 'input[type="email"]:not(.abandoned-cart-modal__email), .form-control.email';

    delegateEvent('focusout', selector, function (event) {
        const email = event.target?.value;
        modalComponentInstance.open(email);
    });
}

/**
 * Session variable with a custom expiry time, to know if Consnet Modal
 * has been deliberately closed.
 */
const consentModalClosed = {
    key: 'consent-modal-closed',
    /**
     * Returns closed state value if item exist
     *  or null if it doesn't exist or it's expired
     * @returns {boolean|null} Modal has been closed
     */
    get() {
        const item = sessionStorage.getItem(this.key);
        if (!item) return null;

        const modalClosedData = JSON.parse(item);
        if (modalClosedData
            && Date.now() > modalClosedData.expiry) {
            this.remove(this.key);
            return null;
        }

        return !!modalClosedData.value;
    },
    /**
     * Deletes the previously-saved object
     */
    remove() {
        sessionStorage.removeItem(this.key);
    },
    /**
     * Saves an object with:
     *  a boolean value wether consent modal has been closed
     *  a expiry time value
     * @param {boolean} closeState - modal close state
     *
     */
    set(closeState) {
        var expiringTime = BASE_CONFIG.abandonedCartConfig.consentModalClosedExpiringTime;
        const data = {
            value: closeState,
            expiry: Date.now() + (expiringTime * 60 * 60 * 1000)
        };

        sessionStorage.setItem(this.key, JSON.stringify(data));
    }
};

const consentModal = modalFactory.createModalComponent({
    ID: modalFactory.config.MODAL_CONSENT_ID,
    closeFn() {
        consentModalClosed.set(true);
        const modal = document.getElementById(
            modalFactory.config.MODAL_CONSENT_ID
        );
        modal.classList.remove('show');
    },
    initializeFn() {
        /** @type {modalFactory.ModalComponentInstance} */
        const me = this;
        setEmailBlurEvent(me);
    },
    isEnabledFn() {
        const modalEnabled = BASE_CONFIG.abandonedCartConfig.modalEnabled;
        const sfmcCollectEnabled = BASE_CONFIG.sfmc.collectEnabled;
        return sfmcCollectEnabled && modalEnabled;
    },
    openFn(email) {
        /** @type {modalFactory.ModalComponentInstance} */
        const me = this;
        me.setEmail(email);
        const modal = document.getElementById(
            modalFactory.config.MODAL_CONSENT_ID
        );
        modal.classList.add('show');
    },
    async shouldOpenAsyncFn(email) {
        if (!validateEmail(email)) {
            return false;
        }

        if (consentModalClosed.get()) {
            return false;
        }

        return isAnonymousCustomer();
    }
});

module.exports = consentModal;
